package pl.decks.personal.components.widgets.ranks

import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import com.varabyte.kobweb.silk.style.extendedByBase
import com.varabyte.kobweb.silk.style.vars.animation.TransitionDurationVars
import com.varabyte.kobweb.silk.theme.colors.palette.color
import com.varabyte.kobweb.silk.theme.colors.palette.toPalette
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.times
import pl.decks.personal.styles.FontTypography
import pl.decks.personal.styles.SiteLayout

object RanksStylesheet {
    object Vars {
        val rankEntryWidth by StyleVariable<CSSLengthOrPercentageNumericValue>(90.px)
        val gap by StyleVariable<CSSLengthOrPercentageNumericValue>(SiteLayout.Space.XSmall)

        val badgeAspectRatio by StyleVariable(AspectRatio.of(2, 5))
        val badgeHeight by StyleVariable<CSSLengthOrPercentageNumericValue>(100.px)

        val levelColor by StyleVariable<Color>()
        val titleColor by StyleVariable<Color>()

        val appearDuration by StyleVariable(TransitionDurationVars.Slow.value())
        val appearPositionDelay by StyleVariable(TransitionDurationVars.Instant.value())

        object Insignia {
            val topBottomPadding by StyleVariable(10.percent)
            val lineRelSize by StyleVariable(8.percent)
            val chevronRelSize by StyleVariable(14.percent)
            val starRelSize by StyleVariable(60.percent)
            val lineLineRelGap by StyleVariable(4.percent)
        }
    }

    object Shapes {
        val Star = CssStyle.base {
            Modifier.width(Vars.Insignia.starRelSize.value()).aspectRatio(1)
        }
        val Chevron = CssStyle.base {
            Modifier.fillMaxWidth().height(Vars.Insignia.chevronRelSize.value())
        }
        val Line = CssStyle.base {
            Modifier.fillMaxWidth().height(Vars.Insignia.lineRelSize.value())
        }

    }

    val Preview = CssStyle.base {
        Modifier
            .overflow(Overflow.Hidden)
            .minWidth(Vars.rankEntryWidth.value() * 1.5)
            .gap(Vars.gap.value())

    }
    val Slots = CssStyle.base {
        Modifier
            .fillMaxWidth()
            .overflow(Overflow.Auto)
            .alignItems(AlignItems.Stretch)
            .gap(Vars.gap.value())
    }
    val SlotRank = CssStyle.base {
        Modifier
            .width(Vars.rankEntryWidth.value())
            .flexShrink(0)
            .gap(SiteLayout.Space.XSmall)
    }
    val SlotBadge = CssStyle.base {
        Modifier
            .aspectRatio(Vars.badgeAspectRatio.value())
            .height(Vars.badgeHeight.value())
    }
    val SlotLevel = FontTypography.mono.extendedByBase {
        Modifier
            .fontSize(FontTypography.Size.Relative.MuchSmaller)
            .whiteSpace(WhiteSpace.NoWrap)
            .textAlign(TextAlign.Center)
            .fillMaxWidth()
            .color(Vars.levelColor.value(colorMode.toPalette().color))
    }
    val SlotTitle = FontTypography.sansSerif.extendedByBase {
        Modifier
            .fontSize(FontTypography.Size.Relative.MuchSmaller)
            .lineHeight(FontTypography.LineHeight.Small)
            .fontWeight(FontWeight.Medium)
            .textAlign(TextAlign.Center)
            .fillMaxWidth()
            .color(Vars.titleColor.value(colorMode.toPalette().color))
    }
    val InstructionText = FontTypography.serif.extendedByBase {
        Modifier
            .fontSize(FontTypography.Size.Small)
            .fontWeight(FontWeight.Light)
    }
}
